/**
 * Preview only. The server validates, calculates, and stores `price`.
 * offeringPrice is a whole major unit (10 = $10). Result price has two decimals.
 */
export type PackagePriceQuote = {
  regularPrice: number;
  savings: number;
  price: number;
  pricePerLesson: number;
};

export function quotePackagePrice(
  offeringPrice: number,
  quantity: number,
  discountPercent: number,
): PackagePriceQuote | null {
  if (!Number.isInteger(offeringPrice) || offeringPrice < 0) return null;
  if (!Number.isInteger(quantity) || quantity < 2) return null;
  if (!Number.isFinite(discountPercent) || discountPercent < 0 || discountPercent >= 100)
    return null;
  const hundredths = Math.round(discountPercent * 100);
  if (Math.abs(discountPercent * 100 - hundredths) >= 1e-6) return null;

  const regularMinor = offeringPrice * quantity * 100;
  const savingsMinor = Math.round((regularMinor * hundredths) / 10_000);
  const packageMinor = regularMinor - savingsMinor;
  const perLessonMinor = Math.round(packageMinor / quantity);
  return {
    regularPrice: regularMinor / 100,
    savings: savingsMinor / 100,
    price: packageMinor / 100,
    pricePerLesson: perLessonMinor / 100,
  };
}
